<template>
    <BContainer class="container-pages" v-if="recipe">
          <BRow>
            <BCol xl="3">
                  <div class="shadow rounded p-element-page bg-white mb-2">
                  <FilterRecipe :categories="recipesDataD.data.categories.data"></FilterRecipe>
                </div>
              </BCol>
              <BCol xl="5" class="mb-3">
                
                <div class="shadow rounded p-element-page bg-white ">
                    <h1 class="h1-title"> {{ recipe.title }}  </h1>
                     <NuxtLink :to="routePath({name:'recepti-category-page',params:{category: $srbTolat.srbTolatPath(recipe.name ),  page: 1}})">
                          <h2 class="h2-subtitle text-info text-uppercase">{{ recipe.name }}</h2>
                    </NuxtLink>
                    <hr>
                </div>
                <div class="container-a mt-2 mb-3" v-if="$screen.showMobileAds">
                 <AdsEventSingleMobile></AdsEventSingleMobile>
                </div>
                <div class="shadow rounded p-element-page bg-white mt-3">
                 <NuxtImg :src="$getImageSrc(recipe.img)"
                      :alt="recipe.title"
                      class="img-fluid w-100"
                      v-if="isVideoEmpty"></NuxtImg>
                   <div
                     v-else
                     class="w-100"
                     style="position: relative; padding-top: 56.25%; overflow: hidden;"
                   >
                    <!-- Native iframe sa loading="lazy" — Google detektuje kao "watch page".
                         Aspect ratio 16:9 inline da ne zavisi od Bootstrap .ratio klase. -->
                    <iframe
                      :src="`https://www.youtube.com/embed/${recipe.video_link}`"
                      :title="recipe.title || 'Recept video'"
                      loading="lazy"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 0;"
                    ></iframe>
                   </div>
               </div>
               <div class="shadow rounded p-element-page bg-white mt-3">
                 <div class="ql-editor p-0" v-html="recipe.description"></div>
               </div>
               <FaqCard v-if="faqList.length" :faq="faqList" class="mt-3"></FaqCard>
               <div class="container-a mt-2 mb-3" v-if="$screen.isProduction">
                 <AdsEventSingleBottom></AdsEventSingleBottom>
               </div>
                      </BCol>
                      <BCol xl="4">
                          <div class="container-a mt-2 mb-3"  v-if="$screen.showDesktopAds">
                           <AdsEventTopRight></AdsEventTopRight>
                          </div>
                          <TopRecipe :items="recipesDataD.data.topRecipes.data"> </TopRecipe>
                      </BCol>
                  </BRow>
      </BContainer>

</template>

<script setup>
import { LazyYoutubeLite } from '#components';
import { BContainer, BCol, BRow } from "bootstrap-vue-next";

import AdsEventTopRight from "~/components/GoogleAdvertisements/AdsEventTopRight.vue"; 
import AdsEventSingleBottom from "~/components/GoogleAdvertisements/AdsEventSingleBottom.vue";
import AdsEventSingleMobile from "~/components/GoogleAdvertisements/AdsEventSingleMobile.vue";
import FilterRecipe from "~/components/cms/recipe/recipe/FilterRecipe"; 
import TopRecipe from "~/components/widgets/Recipe/TopRecipe.vue";
import FaqCard from '~/components/widgets/Advertisement/FaqCard.vue';
import { useShareMetaStore } from "~/stores/shareMeta";
const shareMeta = useShareMetaStore();
import { useRecipeStore } from "~/stores/recipe/recipe";

const config = useRuntimeConfig()

 const routePath = useRoutePath()

const useStore = useRecipeStore();
const route = useRoute();
const { $srbTolat } = useNuxtApp()


const idParam = computed(() => Number(route.params.id))
const categoryParam = computed(() => String(route.params.category))  

const { data: recipesDataD, pending, error, refresh } = await useAsyncData(
  () => `recipe-details-${categoryParam.value}-t${idParam.value}`,
  () => useStore.getRecipeListingDetails({ 
         
          id: idParam.value }),
  {
    watch: [() => categoryParam.value, () => idParam.value],
  }
)
 

const siteUrl =  'https://pijace.com'.replace(/\/$/, '')

const recipe = computed(() => recipesDataD.value?.data?.recipe ?? null)

// cesta pitanja iz CMS-a (dugme FAQ); API vraca { faq: [...] } ili null
const faqList = computed(() => {
  let faq = recipesDataD.value?.data?.faqs?.faq

  if (typeof faq === 'string') {
    try {
      faq = JSON.parse(faq)
    } catch {
      return []
    }
  }

  return Array.isArray(faq) ? faq.filter((item) => item?.question && item?.answer) : []
})

// JSON-LD: FAQPage samo kad recept ima pitanja (isti tekst kao u FaqCard)
const faqLd = computed(() => {
  if (!faqList.value.length) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqList.value.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer
      }
    }))
  }
})

const isVideoEmpty = computed(() => {
  const video = recipe?.value?.video_link
  return video === '' || video === null
})

const headTitle = computed(() => {
  if (!recipe.value) return 'Recepti | Pijace'
  return `${recipe.value.title} | Recepti | Pijace`
})

const headDescription = computed(() => {
  if (!recipe.value) return 'Recepti iz domaće kuhinje: tradicionalni i savremeni recepti, uz pripremu korak-po-korak.'
  // probaj da uzmeš meta opis ako ga imaš u bazi, fallback na “opis” bez HTML
  const meta = recipe.value.description_meta || recipe.value.description || ''
  const plain = String(meta)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  const short = plain.length > 160 ? plain.slice(0, 157) + '...' : plain
  return short || 'Recepti iz domaće kuhinje: tradicionalni i savremeni recepti, uz pripremu korak-po-korak.'
})

const headKeywords = computed(() => {
  if (!recipe.value) return 'recepti, kuvanje, domaća kuhinja, pijace'
  // ključne reči: naslov + kategorija + “recept”
  const base = [
    recipe.value.title,
    recipe.value.name,
    'recept',
    'recepti',
    'kuvanje',
    'domaća kuhinja',
    'Pijace',
  ]
  // ukloni prazno + duplikate
  return [...new Set(base.map(x => String(x || '').trim()).filter(Boolean))].join(', ')
})

const canonicalUrl = computed(() => `${siteUrl}${route.fullPath}`)

const ogImage = computed(() => {
  if (!recipe.value) return `${siteUrl}/api/img/recipe/default.webp`
  return recipe.value.img || `${siteUrl}/api/img/recipe/default.webp`
})

// JSON-LD: Recipe (sa opcionim VideoObject ako postoji youtube link)
const recipeLd = computed(() => {
  if (!recipe.value) return null

  const hasVideo = !!recipe.value.video_link

  // Stabilan datum za uploadDate — koristi created_at/updated_at iz baze,
  // NIKAD new Date() jer to menja vrednost na svakom render-u i kvari
  // search engine caching i strukturisane podatke.
  const datePublished = recipe.value.created_at ?? recipe.value.date_published ?? null
  const dateModified = recipe.value.updated_at ?? recipe.value.date_modified ?? datePublished

  const data = {
    '@context': 'https://schema.org',
    '@type': 'Recipe',
    name: recipe.value.title,
    description: headDescription.value,
    image: [ogImage.value],
    url: canonicalUrl.value,
    inLanguage: 'sr',
    recipeCategory: recipe.value.name,
    ...(datePublished ? { datePublished } : {}),
    ...(dateModified ? { dateModified } : {}),
    author: {
      '@type': 'Organization',
      name: 'Pijace.com',
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Pijace.com',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: `${siteUrl}/images/pijace-60.png`,
      }
    },
  }

  // uploadDate je OBAVEZNO polje za VideoObject (Schema.org).
  // Bez njega Google javlja "Missing field uploadDate". Ako nemamo datum
  // BOLJE je da uopšte ne emitujemo video schema nego da emitujemo broken.
  if (hasVideo && datePublished) {
    const ytId = recipe.value.video_link
    // YouTube JPG thumbnail (JPG, nikad transparent — Google odbija transparent PNG-ove)
    const ytThumb = ytId ? `https://img.youtube.com/vi/${ytId}/maxresdefault.jpg` : null
    // Recipe ima v-html opis koji može biti transparent (logo) — preferiramo YouTube thumb
    const thumb = ytThumb ?? ogImage.value

    data.video = {
      '@type': 'VideoObject',
      name: recipe.value.title,
      description: headDescription.value,
      thumbnailUrl: thumb ? [thumb] : undefined,
      uploadDate: datePublished,
      contentUrl: `https://www.youtube.com/watch?v=${ytId}`,
      embedUrl: `https://www.youtube.com/embed/${ytId}`,
    }
  }

  return data
})

// JSON-LD: BreadcrumbList — Pijace.com → Recepti → kategorija → recept
const breadcrumbLd = computed(() => {
  if (!recipe.value) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Pijace.com',
        item: siteUrl
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Recepti',
        item: `${siteUrl}/recepti/1`
      },
      ...(recipe.value.name
        ? [{
            '@type': 'ListItem',
            position: 3,
            name: recipe.value.name,
            item: `${siteUrl}/recepti/${$srbTolat.srbTolatPath(String(recipe.value.name))}/1`
          }]
        : []),
      {
        '@type': 'ListItem',
        position: recipe.value.name ? 4 : 3,
        name: recipe.value.title,
        item: canonicalUrl.value
      }
    ]
  }
})

watchEffect(() => {
  if (!recipe.value) return
  shareMeta.setMeta({
    title: headTitle.value,
    description: headDescription.value,
    url: canonicalUrl.value,
  })
})

usePijaceSeo({
  title: headTitle,
  description: headDescription,
  url: canonicalUrl,
  type: 'article',
  image: ogImage,
  jsonLd: () => [recipeLd.value, breadcrumbLd.value, faqLd.value],
})

// keywords + robots (specifično za article/recipe stranice — nije pokriveno composable-om)
useHead(() => ({
  meta: [
    { name: 'keywords', content: headKeywords.value },
    {
      name: 'robots',
      content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
    },
  ],
}))

</script>